import React from 'react';
import PropTypes from 'prop-types';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { withStyles } from '@mui/styles';

const CustomTimelineSeparator = withStyles({
  root: {},
})(TimelineSeparator);

const UiTimelineSeparator = ({ children, ...props }) => {
  return (
    <CustomTimelineSeparator {...props}>{children}</CustomTimelineSeparator>
  );
};

UiTimelineSeparator.propTypes = {
  children: PropTypes.array,
};

export default UiTimelineSeparator;
